import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import cn from 'classnames';
import { sum, map } from 'ramda';

import styles from './styles.m.scss';

import { handleError, handleSuccess } from '../../../../../util/forms';
import { apiUpdateRegistration } from '../../../../../api/registration';
import { routes } from '../../../../../routes';

import Footer from '../../../../../components/Accordion/Footer';
import ExperiencesList from '../../../../../components/ExperiencesList';

class Experience extends Component {
  static propTypes = {
    certification: PropTypes.object,
    updateRegistration: PropTypes.func,
    updateRegistrationExperiences: PropTypes.func,
    setStep: PropTypes.func,
    step: PropTypes.number,
  };

  state = {
    experience: {},
    showModal: false,
  };

  render() {
    const { handleSubmit, isSubmitting, isValid, registration, step, setStep } = this.props;
    const totalHours = sum(map((experience) => (experience.approved ? experience.hours : 0), registration.experiences));
    let nextButton = null;
    if (totalHours < registration.requiredHours) {
      nextButton = () => (
        <button type="submit" disabled className="btn btn-primary">
          Progress: {totalHours} / {registration.requiredHours}
        </button>
      );
    }

    return (
      <form>
        <div className="d-flex mb-3">
          <h2 className={cn(styles.stepHeader, 'flex-fill')}>Please add your experience</h2>
          <a
            className="btn btn-primary align-self-center"
            href={routes.certificationsAndTraining.experience.add}
            target="_blank"
          >
            Add Experience
          </a>
        </div>
        <p>
          Please only include information that pertains to your financial counseling and education experience. You will
          need to document a minimum of <strong>{registration.requiredHours} hours</strong> of financial counseling
          experience.{' '}
          <strong>
            You currently have {sum(registration.experiences.map((e) => (e.approved ? e.hours : 0)))} approved hours
          </strong>
        </p>
        {registration.experiences.length > 0 ? (
          <ExperiencesList experiences={registration.experiences} registration={registration} />
        ) : (
          <p className="font-weight-bold">You do not have any approved experience hours yet, please add some.</p>
        )}
        <Footer
          padded
          step={step}
          setStep={setStep}
          isValid={isValid}
          isSubmitting={isSubmitting}
          handleSubmit={handleSubmit}
          finishBtn={nextButton}
        />
      </form>
    );
  }
}

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;

    apiUpdateRegistration(props.registration.id, { stepName: props.name })
      .then(({ data }) => props.updateRegistration(data))
      .then(() => handleSuccess(formProps))
      .then(() => props.setStep(props.step + 1))
      .catch((err) => handleError(formProps, err));
  },
  isInitialValid: true,
  validateOnChange: true,
})(Experience);
